import React from 'react';
import { isBetaActive } from '../../utils/betaMode';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_3876ffd2-0b67-4d0f-be27-32eb0667fc3a/artifacts/g551041i_MIF%20Logo%20White.png";

const LandingFooter = () => (
  <footer className="container mx-auto px-4 sm:px-6 py-8 sm:py-12 border-t border-slate-200">
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8 mb-6 sm:mb-8">
      <div>
        <div className="flex items-center space-x-2 mb-4">
          <img src={LOGO_URL} alt="MyInvestFolio Logo" className="w-10 h-10 object-contain" />
          <span className="text-xl font-serif font-bold text-slate-900">My<span className="text-green-600">Invest</span><span className="text-blue-600">Folio</span></span>
        </div>
        <p className="text-sm text-slate-600" data-testid="footer-tagline">
          Private, independent portfolio infrastructure for discerning investors.{' '}
          {isBetaActive()
            ? 'Currently in beta — Continuity System and Portfolio Clarity open to the public once the beta concludes.'
            : 'Continuity System is open to sign up; Portfolio Clarity is by invitation.'}
        </p>
      </div>
      <div>
        <h3 className="font-semibold text-slate-900 mb-3">Company</h3>
        <div className="space-y-2">
          <button onClick={() => window.location.href = '/about-us'} className="block text-sm text-slate-600 hover:text-slate-900 transition-colors">About Us</button>
          <button onClick={() => window.location.href = '/our-philosophy'} className="block text-sm text-slate-600 hover:text-slate-900 transition-colors">Our Philosophy</button>
          <button onClick={() => window.location.href = '/pricing-layers'} className="block text-sm text-slate-600 hover:text-slate-900 transition-colors">Pricing Layers</button>
          <button onClick={() => window.location.href = '/perspectives'} className="block text-sm text-slate-600 hover:text-slate-900 transition-colors">Perspectives</button>
        </div>
      </div>
      <div>
        <h3 className="font-semibold text-slate-900 mb-3">Professionals</h3>
        <div className="space-y-2">
          <button onClick={() => window.location.href = '/for-advisors'} className="block text-sm text-slate-600 hover:text-slate-900 transition-colors">For Trusted Professionals</button>
          <button onClick={() => window.location.href = '/briefing'} className="block text-sm text-slate-600 hover:text-slate-900 transition-colors">Request a Briefing</button>
          <button onClick={() => window.location.href = '/admin/login'} className="block text-sm text-slate-600 hover:text-slate-900 transition-colors">Admin Portal</button>
        </div>
      </div>
      <div>
        <h3 className="font-semibold text-slate-900 mb-3">Legal</h3>
        <div className="space-y-2">
          <button onClick={() => window.location.href = '/privacy-policy'} className="block text-sm text-slate-600 hover:text-slate-900 transition-colors">Privacy Policy</button>
          <button onClick={() => window.location.href = '/terms-of-service'} className="block text-sm text-slate-600 hover:text-slate-900 transition-colors">Terms of Service</button>
          <button onClick={() => window.location.href = '/cookie-policy'} className="block text-sm text-slate-600 hover:text-slate-900 transition-colors">Cookie Policy</button>
        </div>
      </div>
    </div>
    <div className="border-t border-slate-200 pt-6">
      <div className="flex flex-col md:flex-row justify-between items-center gap-4">
        <div className="text-sm text-slate-500">&copy; 2026 MyInvestFolio. All rights reserved.</div>
        <div className="text-xs text-slate-400">Questions? <a href="mailto:support@myinvestfolio.io" className="hover:text-slate-600">support@myinvestfolio.io</a></div>
      </div>
    </div>
  </footer>
);

export default LandingFooter;
